export default {
  overviewTitle: 'Vergunning Categories',
  detailTitle: 'Vergunning Categorie',
  deleteTitle: 'deze categorie',
  url: '/vehicle/licensecategories',
  apiUrl: '/licensecategories/',
  sortBy: ['category'],
  sortDesc: [false],
  deletable: false,
  editable: true,
  filterName: 'vehicle/licensecategories',
  quickFilter: {
    text: 'Zoek op category',
    value: 'category',
    type: 'text'
  },
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Categorie', value: 'category', link: '/vehicle/licensecategories/{id}', width: '10%'}
  ]
};
